import { appRoutes, tenantsRoute as route } from '@utils/consts';
import { ProtectedRoute } from '@components/protectedRoute';
import { Outlet } from 'react-router';
import { workflowsRoutes } from '../workflows/routes';
import { resourcesRoutes } from '@pages/resources/routes';
import { materialsRoutes } from '@pages/panel/materials/routes';

const routes = [
  {
    path: route.index,
    lazy: async () => {
      const { TenantsProvider } = await import('@contexts/panel/tenants');
      const { TenantsRoot } = await import('@components/panel/tenants');
      return {
        Component: () => (
          <ProtectedRoute panel>
            <TenantsProvider>
              <TenantsRoot />
            </TenantsProvider>
          </ProtectedRoute>
        ),
      };
    },
    children: [
      {
        path: appRoutes.base,
        lazy: async () => {
          const { Tenants } = await import('@pages/panel/tenants');
          return {
            Component: () => <Tenants />,
          };
        },
      },
      {
        path: route.tenant(),
        lazy: async () => {
          const { Tenant } = await import('@pages/panel/tenants/_id');
          return {
            Component: () => (
              <Tenant>
                <Outlet />
              </Tenant>
            ),
          };
        },
        children: [
          {
            path: appRoutes.base,
            lazy: async () => {
              const { TenantDetails } = await import('@pages/panel/tenants/_id/details');
              return {
                Component: () => <TenantDetails />,
              };
            },
          },
          {
            path: route.settings,
            lazy: async () => {
              const { CustomSettingsProvider } = await import(
                '@contexts/panel/tenants/customSettings'
              );
              const { Settings } = await import('@pages/panel/tenants/_id/settings');
              return {
                Component: () => (
                  <CustomSettingsProvider>
                    <Settings />
                  </CustomSettingsProvider>
                ),
              };
            },
          },
          ...resourcesRoutes,
          ...materialsRoutes,
          ...workflowsRoutes,
          {
            path: route.dashboards,
            lazy: async () => {
              const { DashboardsProvider } = await import('@contexts/dashboards');
              const { Dashboards } = await import('@pages/dashboards');
              return {
                Component: () => (
                  <DashboardsProvider>
                    <Dashboards />
                  </DashboardsProvider>
                ),
              };
            },
          },
          {
            path: route.specialties,
            lazy: async () => {
              const { SpecialtiesProvider } = await import('@contexts/panel/tenants/specialties');
              const { Specialties } = await import('@pages/panel/tenants/_id/specialties');
              return {
                Component: () => (
                  <SpecialtiesProvider>
                    <Specialties />
                  </SpecialtiesProvider>
                ),
              };
            },
          },
          {
            path: route.divisions,
            lazy: async () => {
              const { DivisionsProvider } = await import('@contexts/panel/tenants/divisions');
              const { Divisions } = await import('@pages/panel/tenants/_id/divisions');
              return {
                Component: () => (
                  <DivisionsProvider>
                    <Divisions />
                  </DivisionsProvider>
                ),
              };
            },
          },
          {
            path: route.globalItems,
            lazy: async () => {
              const { GlobalItemsProvider } = await import('@contexts/panel/tenants/globalItems');
              const { GlobalItems } = await import('@pages/panel/tenants/_id/globalItems');
              return {
                Component: () => (
                  <GlobalItemsProvider>
                    <GlobalItems />
                  </GlobalItemsProvider>
                ),
              };
            },
          },
        ],
      },
    ],
  },
];

export { routes as tenantsRoutes };
